module.exports = __webpack_public_path__ + "static/img/ndvi5.f1f7cf83.jpg";